/**
 * Redux-persist compatible storage adapter that routes through safeLocalStorage
 * (consent management). Uses the Functional consent group since the persisted
 * whitelist is predominantly functional data (platform, routing, form, config,
 * joyride, infoBanner, preserveFeatureVisibility). Auth data is replicated in
 * flex.oauthData (StrictlyNecessary), so losing the persist blob doesn't break
 * auth — it forces a re-login.
 */
import { getItem, setItem, removeItem, ConsentGroup } from 'lib/safeLocalStorage'

const consentStorage = {
  getItem(key: string): Promise<string | null> {
    return Promise.resolve(getItem(key))
  },
  setItem(key: string, value: string): Promise<void> {
    setItem(key, value, { consentGroup: ConsentGroup.Functional })
    return Promise.resolve()
  },
  removeItem(key: string): Promise<void> {
    removeItem(key)
    return Promise.resolve()
  },
}

export default consentStorage
